import { Button, Flex, Text } from "components";

export default ({ setStep }) => {
  return (
    <Flex column gap="24px">
      <Flex column gap="12px">
        <Text kind="h2" size="24px" weight="bold">
          Please choose the option that works best for you.
        </Text>
      </Flex>
      <Flex gap="12px" center style={{ alignItems: "start" }}>
        <Flex column>
          <a href="https://forms.gle/jEGrAr9Zd8vW3b9UA">
            <Button>Show&Tell builds your event</Button>
          </a>
          <Text size="12px" style={{ marginTop: "8px" }}>
            *requires a lead time of 10 days
          </Text>
        </Flex>
        <Flex center>
          <Button onClick={() => setStep("duplicate-event")}>
            Build your own event
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
